import { useMemo } from "react";
import {
  getDefaultFieldLayout,
  buildFieldLayoutFromSet,
} from "../defaults/fieldLayoutUtils";

export const useSectionFieldLayout = (
  fieldLayoutProp,
  fieldSetId,
  ruleContext = {},
) =>
  useMemo(() => {
    if (fieldLayoutProp) return fieldLayoutProp;
    if (fieldSetId) return getDefaultFieldLayout(fieldSetId, ruleContext);
    return buildFieldLayoutFromSet({ fields: [], tableColumns: [] }, ruleContext);
  }, [fieldLayoutProp, fieldSetId, ruleContext]);

export default useSectionFieldLayout;
